<div *ngIf="!loadingApplication; else loadingApplicationBlock">
  <div id="banner" class="content-block flex-center-row">
    <div id="application-header-block">
      <div class="flex-center-row">
        <h2>{{ application.name }}</h2>
        <ng-container [ngSwitch]="application.syncPhase">
          <div *ngSwitchCase="'failover'" class="sync-phase-glyph recovery-phase">IN RECOVERY</div>
          <div *ngSwitchCase="'failoverTest'" class="sync-phase-glyph recovery-test-phase">RECOVERY TEST</div>
          <div *ngSwitchCase="'release'" class="sync-phase-glyph release-phase">RELEASING</div>
        </ng-container>
        <ng-container>
          <div *ngIf="appIsDeleted" class="sync-phase-glyph deleted-app">
            <i *ngIf="refreshing" class="fa-solid fa-spinner fa-spin"></i>
            DELETING
          </div>
        </ng-container>
      </div>
      <div class="app-description-container">
        {{ sourceDescription }}
        &rarr;
        {{ targetDescription }}
      </div>
    </div>
    <div *ngIf="appResourcesLoaded; else loadingApplicationDetails">
      <ng-container>
        <ng-container *ngIf="!appIsDeleted; else disableSettings">
          <ng-container [ngSwitch]="application.syncPhase">
            <h2 *ngSwitchCase="'release'">
              <i class="fa-utility-fill fa-semibold fa-gear configure-icon disabled-icon"></i>
            </h2>
            <a *ngSwitchDefault class="normal-text" routerLink="configure">
              <h2>
                <i class="fa-utility-fill fa-semibold fa-gear configure-icon"></i>
              </h2>
            </a>
          </ng-container>
        </ng-container>

        <ng-template #disableSettings>
          <h2>
            <i class="fa-utility-fill fa-semibold fa-gear configure-icon disabled-icon"></i>
          </h2>
        </ng-template>
      </ng-container>
    </div>
    <ng-template #loadingApplicationDetails>
      <div id="loading-spinner">
        <h1><i class="fa-solid fa-spinner fa-spin configure-icon"></i></h1>
      </div>
    </ng-template>
    <ng-container *ngIf="recoveryPointAttemptsLoaded">
      <rpo-chart [rpo]="application.rpo" [recoveryPointAttempts]="recoveryPointAttempts"> </rpo-chart>
    </ng-container>
  </div>

  <div class="content-block light-control-host application-dashboard-body">
    <ng-container *ngLet="computeApplicationStatus() as status">
      <div class="flex-center-row">
        <div id="status-text-block">
          <div id="application-status">
            <span *ngIf="appIsDeleted; else notDeleted" class="strong-text deleted">
              <ng-container *ngIf="status.issues.length; else noIssue">
                Recovery environment clean up failed
              </ng-container>
              <ng-template #noIssue>
                <ng-container *ngIf="allResourcesCleaned; else stillCleaning">
                  Finalizing application deletion
                </ng-container>
                <ng-template #stillCleaning> Cleaning up recovery environment resources </ng-template>
              </ng-template>
            </span>
            <ng-template #notDeleted>
              <span class="strong-text" [ngClass]="status.class">
                {{ status.text }}
              </span>
            </ng-template>
            <span class="strong-text" *ngIf="status.issues.length > 0">
              (<a [routerLink]="issuesUrl"
                >Review and fix {{ status.issues.length }} issue<span *ngIf="status.issues.length !== 1">s</span> </a
              >)
            </span>
          </div>
          <div class="secondary-status" *ngIf="isStandby; else recoveryPoint">
            Last successful recovery test:
            {{ latestSuccessfulTestTimeAgoString }}
          </div>
          <ng-template #recoveryPoint>
            <div class="secondary-status">
              Applied recovery point is {{ currentRecoveryPointTimeString }}.
              <ng-container *ngIf="showNetworkSandboxStatus">
                Network sandbox is {{ networkSandboxStatus }}.
                <ng-container
                  *ngIf="
                    application.networkSandboxEnabled &&
                    application.advancedNetworkSandboxEnabled &&
                    applicationSyncPhase == 'failoverTest'
                  "
                >
                  <a (click)="showSandboxEventsDialog()" target="_blank">See most recent events.</a>
                </ng-container>
              </ng-container>
              <ng-container *ngIf="showRansomwareRecoveryStatus">
                Quarantine Mode is
                {{ ransomwareRecoveryStatus }}.</ng-container
              >
              <div
                class="allowlist-status nowrap"
                *ngIf="
                  showNetworkSandboxStatus &&
                  application.advancedNetworkSandboxEnabled &&
                  application.networkSandboxAllowedDomains?.length
                "
              >
                {{ domainAllowlistStatus }}
              </div>
              <div
                class="allowlist-status nowrap"
                *ngIf="
                  showNetworkSandboxStatus &&
                  accountService.networkSandboxWhitelistEnabled &&
                  application.networkSandboxWhitelist?.length
                "
              >
                {{ whitelistStatus }}
              </div>
            </div>
          </ng-template>
          <process-state
            *ngIf="showFailback"
            [justStarted]="this.failbackStarted"
            [ignoreBefore]="lastSyncComplete"
            [status]="this.lastFailback"
          >
          </process-state>
        </div>
        <ng-container *ngIf="showAppActions; else inProgressSpinner">
          <div class="flex-center-row" *ngIf="showSyncActions">
            <button
              *ngIf="showSandboxSettingsButton"
              type="button"
              id="sandbox-config-button"
              class="arpio-button"
              (click)="sandboxConfigButtonClick()"
            >
              SANDBOX SETTINGS
            </button>
            <ng-container [ngSwitch]="applicationSyncPhase">
              <ng-container *ngSwitchCase="'failoverTest'">
                <button
                  type="button"
                  id="conclude-test-button"
                  class="arpio-button"
                  *ngIf="canTest"
                  (click)="concludeTestButtonClick()"
                >
                  CONCLUDE TEST
                </button>
              </ng-container>
              <ng-container *ngSwitchCase="'failover'">
                <button
                  type="button"
                  *ngIf="resourcesAreQuarantined && !appIsDeleted"
                  id="unquarantine-button"
                  class="arpio-button margin-left"
                  (click)="unquarantineButtonClick()"
                >
                  UNQUARANTINE
                </button>
                <button
                  type="button"
                  *ngIf="failbackEnabled && !resourcesAreQuarantined && !appIsDeleted && canRecover"
                  id="failback-button"
                  class="arpio-button margin-left"
                  [disabled]="!hasFailbackResources"
                  (click)="failbackButtonClick()"
                >
                  FAILBACK
                </button>
                <button
                  type="button"
                  id="conclude-recovery-button"
                  class="arpio-danger-button margin-left"
                  *ngIf="!appIsDeleted && canRecover"
                  (click)="concludeRecoveryButtonClick()"
                >
                  CONCLUDE RECOVERY
                </button>
              </ng-container>

              <ng-container *ngSwitchCase="'standby'">
                <ng-container *ngIf="!isStandbyRestoreConcluding && !appIsDeleted">
                  <button
                    type="button"
                    id="test-button"
                    data-cy="test-button"
                    *ngIf="canTest"
                    class="arpio-button"
                    [disabled]="!lastStagingSuccess"
                    (click)="launchTestButtonClick()"
                  >
                    TEST
                  </button>

                  <button
                    type="button"
                    id="failover-button"
                    data-cy="failover-button"
                    *ngIf="canRecover"
                    class="arpio-danger-button"
                    [disabled]="!lastStagingSuccess"
                    (click)="recoverButtonClick()"
                  >
                    LAUNCH RECOVERY
                  </button>
                </ng-container>
                <ng-container *ngIf="isStandbyRestoreConcluding">
                  <h1 class="margin-none">
                    <i class="fa-solid fa-spinner fa-spin"></i>
                  </h1>
                </ng-container>
              </ng-container>
            </ng-container>
          </div>
        </ng-container>
        <ng-template #inProgressSpinner>
          <h1 class="margin-none">
            <i class="fa-solid fa-spinner fa-spin"></i>
          </h1>
        </ng-template>
      </div>
      <hr />
      <ng-container>
        <app-resources-view
          *ngIf="activeTab === Tab.RECOVERY; else failbackTabBlock"
          [tabType]="Tab.RECOVERY"
          [loading]="!appResourcesLoaded || resourcesRefreshing"
          [resources]="getResources(status.relevantStatus)"
          [application]="application"
          [appIsDeleted]="appIsDeleted"
          [initialFilterText]="filterText"
          (filterTextChange)="doFilterResources($event)"
        >
          <div class="showFailback-buttons margin-bottom">
            <div *ngIf="showFailback; else resourcesHeading" class="tab">
              <button
                type="button"
                id="recovery-tab"
                [ngClass]="{ active: activeTab === Tab.RECOVERY }"
                (click)="showRecoveryTab()"
                [disabled]="appIsDeleted"
              >
                <h3 [ngClass]="{ inactive: activeTab !== Tab.RECOVERY }">Recovery</h3>
              </button>
              <button
                type="button"
                [ngClass]="{ active: activeTab === Tab.FAILBACK }"
                (click)="showFailbackTab()"
                [disabled]="appIsDeleted"
              >
                <h3 [ngClass]="{ inactive: activeTab !== Tab.FAILBACK }">Failback</h3>
              </button>
            </div>
            <ng-template #resourcesHeading>
              <h3 class="margin custom-margin">Resources</h3>
            </ng-template>
          </div>

          <div class="refresh-btn">
            <button
              type="button"
              id="refresh-button"
              class="arpio-secondary-button small-button"
              (click)="refreshButtonClick()"
            >
              <i [class.active]="manualRefreshing" class="fa-solid fa-spinner fa-spin refresh-spinner"></i>
              REFRESH
            </button>
          </div>
        </app-resources-view>
        <ng-template #failbackTabBlock>
          <app-resources-view
            [tabType]="Tab.FAILBACK"
            [appStatus]="lastFailback"
            [resources]="getFailbackResources()"
            [application]="application"
            [appIsDeleted]="appIsDeleted"
            [initialFilterText]="filterText"
            (filterTextChange)="doFilterResources($event)"
          >
            <div class="showFailback-buttons margin-bottom">
              <div *ngIf="showFailback; else resourcesHeading" class="tab">
                <button
                  type="button"
                  id="recovery-tab"
                  [ngClass]="{ active: activeTab === Tab.RECOVERY }"
                  (click)="showRecoveryTab()"
                >
                  <h3 [ngClass]="{ inactive: activeTab !== Tab.RECOVERY }">Recovery</h3>
                </button>
                <button
                  type="button"
                  [ngClass]="{ active: activeTab === Tab.FAILBACK }"
                  (click)="showFailbackTab()"
                  [disabled]="appIsDeleted"
                >
                  <h3 [ngClass]="{ inactive: activeTab !== Tab.FAILBACK }">Failback</h3>
                </button>
              </div>
              <ng-template #resourcesHeading>
                <h3 class="margin custom-margin">Resources</h3>
                <i *ngIf="refreshing" class="fa-solid fa-spinner fa-spin resources-spinner"></i>
              </ng-template>
            </div>

            <div class="refresh-btn">
              <button
                type="button"
                id="refresh-button"
                class="arpio-secondary-button small-button"
                (click)="refreshButtonClick()"
              >
                <span class="refresh-content" [class.faded]="manualRefreshing">REFRESH</span>
                <i *ngIf="manualRefreshing" class="fa-solid fa-spinner fa-spin refresh-spinner"></i>
              </button>
            </div>
          </app-resources-view>
        </ng-template>
      </ng-container>
    </ng-container>
  </div>
</div>

<ng-template #loadingApplicationBlock>
  <h1 id="application-loading" class="content-block"><i class="fa-solid fa-spinner fa-spin"></i> Loading</h1>
</ng-template>

<modal-dialog #failoverDialog [dialogTemplate]="failoverDialogTemplate"></modal-dialog>

<ng-template #failoverDialogTemplate>
  <div class="flex-center-column full-width">
    <div class="dialog light-content-panel double-margin-top">
      <launch-recovery-dialog
        *ngIf="!showAreYouSure"
        [launching]="launchingSync"
        [application]="application"
        (cancel)="dismissModal()"
        (launch)="onLaunchRecovery($event)"
      >
      </launch-recovery-dialog>

      <div *ngIf="showAreYouSure" class="flex-center-column full-width light-control-host">
        <div class="">
          <h3>Are you sure you want to launch recovery for the following applications?</h3>
          <div class="margin-top font-bold" *ngIf="quarantineEnabled; else quarantineOff">Quarantine Mode : ON</div>
          <ng-template #quarantineOff>
            <div class="margin-top font-bold">Quarantine Mode : OFF</div>
          </ng-template>
          <ul>
            <li *ngFor="let app of selectedApplications">{{ app.name }}</li>
          </ul>
          <div class="notice-block indeterminate">
            Launching a Recovery will restore your application in your recovery environment without the safeguards of a
            Test.
            <a href="{{ uiService.testVsRecoveryFaq }}" target="_blank">Learn more.</a>
          </div>
        </div>
        <div class="flex-center-row justify-center full-width margin-top">
          <button type="button" class="arpio-secondary-button" (click)="onCancelRecoveryConfirmation()">
            No, Cancel Recovery
          </button>
          <button type="button" class="arpio-danger-button text-white margin-left" (click)="confirmLaunchRecovery()">
            Yes, I'm sure
          </button>
        </div>
      </div>
    </div>
  </div>
</ng-template>

<modal-dialog #concludeFailoverDialog [dialogTemplate]="concludeFailoverDialogTemplate"></modal-dialog>

<ng-template #concludeFailoverDialogTemplate>
  <div class="flex-center-column">
    <div class="dialog light-content-panel double-margin-top">
      <conclude-recovery-dialog
        [launching]="launchingSync"
        [application]="application"
        (cancel)="dismissConcludeModal()"
        [currentlySyncing]="application.currentlyRestoring && !launchingSync"
        (conclude)="concludeRecovery($event)"
      >
      </conclude-recovery-dialog>
    </div>
  </div>
</ng-template>

<modal-dialog #testFailoverDialog [dialogTemplate]="testFailoverDialogTemplate"></modal-dialog>

<ng-template #testFailoverDialogTemplate>
  <div class="flex-center-column full-width">
    <div class="dialog light-content-panel double-margin-top">
      <launch-test-dialog
        [launching]="launchingSync"
        [application]="application"
        [currentlySyncing]="application.currentlyRestoring && !launchingSync"
        (cancel)="dismissLaunchTestModal()"
        (launch)="launchTest($event)"
      >
      </launch-test-dialog>
    </div>
  </div>
</ng-template>

<modal-dialog #sandboxConfigDialog [dialogTemplate]="sandboxConfigDialogTemplate"></modal-dialog>

<ng-template #sandboxConfigDialogTemplate>
  <div class="flex-center-column full-width">
    <div class="dialog test-config-dialog light-content-panel double-margin-top">
      <application-test-config-dialog
        [launching]="launchingSync"
        [application]="application"
        [currentlySyncing]="application.currentlyRestoring && !launchingSync"
        (cancel)="dismissSandboxConfigModal()"
        (launch)="launchTest($event)"
      >
      </application-test-config-dialog>
    </div>
  </div>
</ng-template>

<modal-dialog #concludeTestFailoverDialog [dialogTemplate]="concludeTestFailoverDialogTemplate"></modal-dialog>

<ng-template #concludeTestFailoverDialogTemplate>
  <div class="flex-center-column full-width">
    <div class="dialog light-content-panel double-margin-top">
      <conclude-test-dialog
        [launching]="launchingSync"
        [application]="application"
        (cancel)="dismissConcludeTestModal()"
        (conclude)="concludeTestFailover($event)"
      ></conclude-test-dialog>
    </div>
  </div>
</ng-template>

<modal-dialog #failbackDialog [dialogTemplate]="failbackDialogTemplate"></modal-dialog>

<ng-template #failbackDialogTemplate>
  <div class="flex-center-column full-width">
    <div class="failback-dialog light-content-panel double-margin-top">
      <failback-dialog
        [application]="application"
        [launching]="launchingFailback"
        (failback)="launchFailback($event)"
        (cancel)="dismissFailbackModal()"
      ></failback-dialog>
    </div>
  </div>
</ng-template>

<modal-dialog #unquarantineDialog [dialogTemplate]="unquarantineDialogTemplate"></modal-dialog>

<ng-template #unquarantineDialogTemplate>
  <div class="flex-center-column full-width">
    <div class="dialog light-content-panel double-margin-top">
      <unquarantine-dialog [application]="application" (close)="dismissUnquarantineModal()"></unquarantine-dialog>
    </div>
  </div>
</ng-template>
